<template>
  <e-charts
    ref="line"
    autoresize
    :option="option"
    theme="theme-color"
    auto-resize
    :update-options="{notMerge:true}"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import { ref, toRef, watch } from '@vue/composition-api'
import { formatCpf, formatCurrency, truncateString } from '@core/utils/utils'
import { registerTheme, use } from 'echarts/core'
import {
  BarChart, LineChart, LinesChart, PieChart,
} from 'echarts/charts'
import {
  DatasetComponent,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  LegendScrollComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components'
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'
import theme from '../theme.json'

use([
  BarChart,
  LineChart,
  PieChart,
  LinesChart,
  LegendScrollComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  CanvasRenderer,
  SVGRenderer,
  ToolboxComponent,
  DataZoomComponent,
])
registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    mobile: {
      type: Object,
      default: () => ({ mobile: false }),
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const chartData = toRef(props, 'chartData')
    // const mobile = toRef(props, 'mobile')

    const dataset = {
      dimensions: ['name', 'total_advanced', 'short', 'cpf'],
      source: [],
    }
    const option = ref({
      grid: {
        left: 170,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: ([data]) => `<strong>${data.data[0]}</strong><br/>${formatCpf(data.data[3])}<br/>${formatCurrency(data.data[1])}`,
      },
      dataset: [dataset],
      yAxis: {
        inverse: true,
        type: 'category',
        axisLabel: {
          interval: 0,
          rotate: 30,
        },
      },
      xAxis: {
        axisLabel: {
          formatter: formatCurrency,
          rotate: 30,
        },
      },
      series: [
        {
          type: 'bar',
          colorBy: 'data',
          encode: { y: 'short', x: 'total_advanced' },
        },
      ],
    })

    watch(chartData, data => {
      if (!data || !data.total_year_per_physician) return
      const years = Object.keys(data.total_year_per_physician)
      const physicians = years.length > 0 ? Object.values(data.total_year_per_physician[years[0]]) : []

      dataset.source.splice(0, dataset.source.length)
      const labels = physicians.map(i => i.name)
      const cpfs = physicians.map(i => i.cpf)
      physicians.forEach((i, index) => {
        const label = labels[index]
        const cpf = cpfs[index] || '00000000000'
        const value = i.total_advanced_year / 100
        const shortLabel = truncateString(labels[index], 15)
        dataset.source.push([label, value, shortLabel, cpf])
      })
    })

    return {
      option,
    }
  },
}
</script>
